import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { useOverlayActions } from '../../contexts/StoreContext';
import { Logo } from './Logo';
import { CartButton } from './CartButton';

/**
 * De rustige balk bovenin Mijn omgeving, in plaats van de winkelheader: het logo (naar de
 * homepage), "Mijn omgeving", een weg terug naar de webshop en de winkelmand. Het eigen menu
 * staat in het zijmenu en de duimbalk. Even hoog als de compacte winkelheader (68 px), zodat er
 * niets verspringt; hij blijft staan bij scrollen.
 */
export function AccountHeader() {
  const {
    openCart
  } = useOverlayActions();
  return <header className="sticky top-0 z-header border-b border-line bg-shell/95 backdrop-blur-md" data-id="element-7933" data-mp="3ff3edkmuui53">
      <div className="mx-auto flex h-[68px] max-w-content items-center gap-4 px-5 sm:px-6 lg:px-10" data-id="element-7934" data-mp="3kdodthua8xsh">
        <Logo className="h-9" data-id="element-7935" data-mp="bye7tyn9v8ff" />
        <span aria-hidden="true" className="h-6 w-px shrink-0 bg-line" data-id="element-7936" data-mp="bxcshhz83zrw" />
        <Link to="/account" className="min-w-0 truncate text-[14px] text-clay transition-colors duration-150 ease-soft hover:text-ink" data-id="element-7937" data-mp="grgz204ku5sg">
          Mijn omgeving
        </Link>
        <div className="ml-auto flex shrink-0 items-center gap-2" data-id="element-7938" data-mp="2onzqnyocyhov">
          <Link to="/webshop" className="hidden items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-2.5 text-[13px] text-muted transition-colors duration-150 ease-soft hover:text-ink sm:inline-flex" data-id="element-7939" data-mp="32e36a6sqfd5c">
            <ArrowLeftIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7940" data-mp="3cb7u0b287go9" />
            Naar de webshop
          </Link>
          <span className="-mr-2" data-id="element-7941" data-mp="37firbyuwtjnq">
            <CartButton onClick={openCart} data-id="element-7942" data-mp="3ldpiyx99mney" />
          </span>
        </div>
      </div>
    </header>;
}